// import React, { useEffect, useState, useContext } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   Legend,
// } from "recharts";
// import { InverterDetail2 } from "../../../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";
// import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";

// const Tab4DailyEnergy = () => {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tye] = useState("I");

//   const getCredentials = () => ({
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     LOC_CODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     TYE: tye,
//   });

//   const fetchLogData = async () => {
//     setLoading(true);
//     const credentials = getCredentials();
//     try {
//       const res = await InverterDetail2(credentials);

//       if (res?.data && Array.isArray(res.data)) {
//         const transformedData = res.data.map((item) => ({
//           name: item.NAME,
//           DAY_KWH: parseFloat(item.DAY_KWH) || 0,
//           CUF: parseFloat(item.CUF) || 0,
//         }));
//         setChartData(transformedData);
//       } else {
//         setChartData([]);
//         // console.error("Data structure mismatch:", res);
//       }
//     } catch (err) {
//       // console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   return (
//     <div className="row">
//       <div className="col-md-12" style={{ height: "12rem", position: "relative" }}>
//         {/* Refresh Button */}
//         <div
//           style={{
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             zIndex: 1,
//           }}
//         >
//           <IconButton onClick={fetchLogData} disabled={loading}>
//             <Refresh />
//           </IconButton>
//           {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//         </div>

//         {/* Chart */}
//         {loading ? (
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "100%",
//             }}
//           >
//             <CircularProgress />
//           </div>
//         ) : (
//           <ResponsiveContainer>
//             <ComposedChart
//               data={chartData}
//               margin={{ top: 0, right: 40, left: 40, bottom: 0 }}
//             >
//               <CartesianGrid strokeDasharray="3 3" />

//               {/* X Axis */}
//               <XAxis
//                 dataKey="name"
//                 angle={-45}
//                 textAnchor="end"
//                 height={70}
//                 tick={{ fontSize: 12 }}
//               />

//               {/* Y Axis for kWh */}
//               <YAxis
//                 yAxisId="left"
//                 tick={{ fontSize: 12 }}
//                 label={{ value: "Today kWh", angle: -90, position: "insideLeft", offset: 10 }}
//               />

//               {/* Y Axis for CUF */}
//               <YAxis
//                 yAxisId="right"
//                 orientation="right"
//                 tick={{ fontSize: 12 }}
//                 label={{ value: "CUF", angle: 90, position: "insideRight", offset: 10 }}
//               />

//               {/* Tooltip & Legend */}
//               <Tooltip />
//               <Legend
//                 layout="horizontal"
//                 verticalAlign="top"
//                 align="center"
//                 wrapperStyle={{ fontSize: "12px", paddingBottom: "10px" }}
//               />

//               {/* Bar: Today kWh */}
//               <Bar
//                 dataKey="DAY_KWH"
//                 yAxisId="left"
//                 fill="#00C49F"
//                 name="Today kWh"
//                 barSize={30}
//               />

//               {/* Line: CUF */}
//               <Line
//                 type="monotone"
//                 dataKey="CUF"
//                 yAxisId="right"
//                 stroke="red"
//                 strokeWidth={2}
//                 dot={{ r: 3 }}
//                 name="CUF"
//               />
//             </ComposedChart>
//           </ResponsiveContainer>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Tab4DailyEnergy;


import React, { useEffect, useState, useContext ,forwardRef} from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  Legend,
} from "recharts";
import { InverterDetail2 } from "../../../../../../../../api/Api";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";

const Tab4DailyEnergy = forwardRef(function Tab4YearlyEnergy(props, ref) {

  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tye] = useState("I");

  const getCredentials = () => ({
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    LOC_CODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    TYE: tye,
  });

  const fetchLogData = async () => {
    setLoading(true);
    const credentials = getCredentials();
    try {
      const res = await InverterDetail2(credentials);

      if (res?.data && Array.isArray(res.data)) {
        const transformedData = res.data.map((item) => ({
          name: item.NAME,
          DAY_KWH: parseFloat(item.DAY_KWH) || 0,
          CUF: parseFloat(item.CUF) || 0,
        }));
        setChartData(transformedData);
      } else {
        setChartData([]);
        // console.error("Data structure mismatch:", res);
      }
    } catch (err) {
      // console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchLogData();
  // }, []);

  useEffect(() => {
    // First fetch on component mount
    fetchLogData();
  
    // Auto refresh every 5 minutes (300000 ms)
    const interval = setInterval(() => {
      fetchLogData();
    }, 300000); // 5 minutes
  
    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);
  

  return (
    <div className="row">
      <div ref={ref} className="col-md-12" style={{ height: "12rem", position: "relative" }}>
        {/* Refresh Button */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1,
          }}
        >
          <IconButton onClick={fetchLogData} disabled={loading}>
            <Refresh />
          </IconButton>
          {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
        </div>

        {/* Chart */}
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <ResponsiveContainer>
            <ComposedChart
              data={chartData}
              margin={{ top: 0, right: 40, left: 40, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" />

              {/* X Axis */}
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={70}
                tick={{ fontSize: 12 }}
              />

              {/* Y Axis for kWh */}
              <YAxis
                yAxisId="left"
                tick={{ fontSize: 12 }}
                label={{ value: "Today kWh", angle: -90, position: "insideLeft", offset: 10 }}
              />

              {/* Y Axis for CUF */}
              <YAxis
                yAxisId="right"
                orientation="right"
                tick={{ fontSize: 12 }}
                label={{ value: "CUF", angle: 90, position: "insideRight", offset: 10 }}
              />

              {/* Tooltip & Legend */}
              <Tooltip />
              <Legend
                layout="horizontal"
                verticalAlign="top"
                align="center"
                wrapperStyle={{ fontSize: "12px", paddingBottom: "10px" }}
              />

              {/* Bar: Today kWh */}
              <Bar
                dataKey="DAY_KWH"
                yAxisId="left"
                fill="#00C49F"
                name="Today kWh"
                barSize={30}
              />

              {/* Line: CUF */}
              <Line
                type="monotone"
                dataKey="CUF"
                yAxisId="right"
                stroke="red"
                strokeWidth={2}
                dot={{ r: 3 }}
                name="CUF"
              />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
});

export default Tab4DailyEnergy;

